/**
 * Whether a diagnosis the system graded `low` is proposed to this tenant's
 * teachers (approve or reject) or withheld, like one graded `none`. Medium is
 * always proposed; high is always used.
 *
 * The editor of the `diagnosisReview` tenant setting, framed by
 * TenantSettingsTab. See docs/FeatureDesigns/diagnosis/accuracy/diagnosis-review-target.md.
 */
import { useState } from 'react';
import { Button, Select } from '@shared-ui/components';
import type { SettingEditorProps } from './TenantSettingsTab';

export function DiagnosisReviewEditor({ value, save, saving, actions }: SettingEditorProps<'diagnosisReview'>) {
    const [proposeLow, setProposeLow] = useState(value.proposeLow);
    const dirty = proposeLow !== value.proposeLow;
    return (
        <div className="tenants-form">
            <label>
                Low-confidence diagnoses{' '}
                <Select aria-label="Low-confidence diagnoses" value={proposeLow ? 'propose' : 'withhold'} onChange={e => setProposeLow(e.target.value === 'propose')}>
                    <option value="propose">Ask the teacher</option>
                    <option value="withhold">Withhold</option>
                </Select>
            </label>
            <div className="tenant-detail-save">
                {dirty && <span className="tenant-detail-note">Unsaved changes</span>}
                {actions}
                <Button onClick={() => save({ proposeLow })} loading={saving} disabled={!dirty}>Save</Button>
            </div>
        </div>
    );
}
